const salesMenu = [
  {
    System: 'SAL',
    menu: [
      // { is_header: true, title: 'Sales', isActive: true },
      { is_header: true, title: '', isActive: true },

      {
        path: '/SAL/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/SAL/Quotation',
        icon: 'fas fa-file-alt',
        title: 'Quotations',
        permission: 'SALViewQuotationList',
        isActive: true
      },

      {
        path: '/SAL/SellOrder',
        icon: 'fas fa-shopping-cart',
        title: 'SellOrder',
        permission: 'SALViewSellOrderList',
        isActive: true
      },

      {
        path: '/SAL/SalesReturn',
        icon: 'fas fa-undo',
        title: 'SalesReturn',
        permission: 'SALViewReturnSellOrderList',
        isActive: true
      },
      {
        path: '/SAL/SalesTypes',
        icon: 'fas fa-list-alt',
        title: 'أنواع المبيعات',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/SAL/Customers',
        icon: 'fas fa-users',
        title: 'Customers',
        permission: 'SALViewCustomersList',
        isActive: true
      },

      {
        path: '/SAL/PriceList',
        icon: 'fas fa-tags',
        title: 'PriceList',
        permission: 'SALViewPriceListList',
        isActive: true
      },
      {
        path: '/SAL/Vouchers',
        icon: 'bi bi-ticket-perforated',
        title: 'العروض الترويجية',
        permission: 'SALViewVouchersList',
        isActive: true
      },
      // {
      //   path: 'SalesSettings/Vouchers',
      //   icon: 'fas fa-ticket-alt',
      //   title: 'Vouchers',
      //   isActive: false,
      // },
      // {
      //   path: 'SalesSettings/Vouchers2',
      //   icon: 'fas fa-ticket-alt',
      //   title: 'Vouchers',
      //   isActive: false,
      // },

      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/SAL/SalesReports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },
      {
        path: '/SAL/SalesDashboards',
        icon: 'fas fa-tachometer-alt',
        title: 'Dashboard',
        isActive: true
      }
    ]
  }
];

export default salesMenu;
